import React, {useState} from 'react';
import './index.scss';
import classNames from 'classnames';
import ColumnTitleWithIcon from '../ColumnTitleWithIcon/index.js';
import DropdownMultiSelect from '../DropdownMultiSelect/index.js';
import {getReconciliationSettings} from "../../../store/selectors.js";
import {useSelector} from "react-redux";

const ReconciliationsMultiSelect = props => {
  const { column, values, item, getData, onPropChange } = props;
  let list= [];
  const state = useSelector(getReconciliationSettings);
  const [selectedValues, setSelectedValues] = useState(item[column.accessor] || []);

  if(state && column && column.getDefaultData) {
      const result = column.getDefaultData(state);
      list = values;
      if(result && result.length > 0) {
          if(!item.refreshedValue || item[column.refreshedId] === item.refreshedValue ){

              list = [...result, ...values];
              list = list.filter((item, index, array) => {
                  return index === array.findIndex(obj => obj.key === item.key);
              });
              list.sort((a, b) => {
                  if (!a || !a.key) return 1;
                  if (!b || !b.key) return -1;
                  return a.key.localeCompare(b.key);
              })
          }

          if(!item.isDirty) {
              item.isDirty = true;
              item.refreshedValue = item[column.refreshedId];
              const currentValues = result.map(depot => depot.value);
              setSelectedValues(currentValues);
          }
          // defaultName = result;
      }


  }

  const handleOnChange = items => {
    if (column.action && items) {
      getData(column.action, items);
    }


      const keysSet = new Set(list.map(obj => obj.value));
      const filteredKeys = items.filter(key => keysSet.has(key));
    if (column.onPropChange) {
      column.onPropChange(items, column, onPropChange);
    } else {
      const dataToRefresh = column.dataToRefresh || {};
      onPropChange({ ...dataToRefresh, [column.accessor]: filteredKeys });
    }
    setSelectedValues(filteredKeys);
  };

  return (
    <div className={'reconciliationsMultiSelect'}>
      <div
        key={`propItem-${column.accessor}`}
        className={classNames('sectionItemSelect', {
          required: column.isRequired,
          isInline: column.isInline,
          withoutBorder: column?.withoutBorder,
        })}
        style={{ width: column?.width}}
      >
        <ColumnTitleWithIcon item={item} column={column} onPropChange={onPropChange} />
        <DropdownMultiSelect
          isMultiMode
          values={list}
          defaultPlaceholderValues={null}
          placeholderMulti={column?.placeholderMulti ? column?.placeholderMulti(selectedValues, list) : " "}
          selectedValues={selectedValues}
          onApply={item => handleOnChange(item)}
        />
      </div>
    </div>
  );
};

export default ReconciliationsMultiSelect;
